import { render, staticRenderFns } from "./TurnstilesDataTable.vue?vue&type=template&id=88e9d3c0&scoped=true"
import script from "./TurnstilesDataTable.vue?vue&type=script&lang=js"
export * from "./TurnstilesDataTable.vue?vue&type=script&lang=js"
import style0 from "./TurnstilesDataTable.vue?vue&type=style&index=0&id=88e9d3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e9d3c0",
  null
  
)

export default component.exports